import { render, staticRenderFns } from "./assign_user_dialog.vue?vue&type=template&id=7c235e15&scoped=true&"
import script from "./assign_user_dialog.vue?vue&type=script&lang=js&"
export * from "./assign_user_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c235e15",
  null
  
)

export default component.exports